// import { ContentContainer } from 'themes/canvas/components/ContentContainer';
import s from './Hero.module.css';

interface HeroProps {
  imgSrc: string;
  href?: string;
}

const Hero = ({ imgSrc }: HeroProps) => {
  return (
    <section className={s.hero}>
      <figure
        className={s.background}
        style={{
          backgroundImage: `url(${imgSrc})`,
        }}
      />
    </section>
  );
};

export { Hero };
